export default __webpack_public_path__ + "static/media/NotoSans-Thin.9a721644.woff2";